import { render } from "./EmpfehlungNew.vue?vue&type=template&id=b5607268"
import script from "./EmpfehlungNew.vue?vue&type=script&lang=js"
export * from "./EmpfehlungNew.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__